import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Title } from "@mantine/core";

import { OrganizationForm, OrganizationList } from "./";
import { ManagementLayout } from "@components/shared";

export default function OrganizationManagement() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);

  return (
    <ManagementLayout
      dataComponent={<OrganizationList refresh={refresh} />}
      createComponent={
        <Card>
          <Title order={4}>
            {t("create")} {t("cs:organization_singular")}
          </Title>
          <OrganizationForm
            onSuccess={(orgId) => {
              setRefresh(!refresh);
              if (orgId) navigate(`/organizations/${orgId}`);
            }}
          />
        </Card>
      }
    />
  );
}
